// d06665ebe0d5eb3fe188ec137a555da003903dad|name=FileApiGetUploadUrlParams|schemaHash=922b781ab25fa3e280ee63e1c2109d269cc31bc4|kind=parser-js

import { setDefinedValue } from '@myre/common-primitives';

export function parseFileApiGetUploadUrlParamsFromJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(result, 'customerId', _data.customerId);
  setDefinedValue(result, 'contentType', _data.contentType);
  setDefinedValue(result, 'ext', _data.ext);

  return result;
}

export function parseFileApiGetUploadUrlParamsToJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(result, 'customerId', _data.customerId);
  setDefinedValue(result, 'contentType', _data.contentType);
  setDefinedValue(result, 'ext', _data.ext);

  return result;
}
